import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from '@components/Button/Button';
import { theme } from 'antd';
import { memo } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router';

import { REGISTRY, VACCIANTION } from '@/constants/routes';
import { UUID } from '@/shared/api/types';

import { canFarmAction } from '../FarmingTable/FarmingTable';
import cl from './styles.module.scss';

const { useToken } = theme;

export interface FarmingCellProps {
  id: UUID | null;
  individualInventoryNumber: UUID | null;
  cellNumber: string;
  columnIndex: number;
  rowIndex: number;
  onAddIndiv: (columnIndex: number, rowIndex: number) => void;
  onClearIndiv: (id: UUID, columnIndex: number, rowIndex: number) => void;
  canAction: canFarmAction;
}

export const FarmingCell = memo(
  ({
    id,
    individualInventoryNumber,
    cellNumber,
    columnIndex,
    rowIndex,
    onAddIndiv,
    onClearIndiv,
    canAction,
  }: FarmingCellProps) => {
    const { token } = useToken();
    const location = useLocation();

    const [searchParams] = useSearchParams();
    const farmId = searchParams.get('id') || '';
    const orgId = searchParams.get('orgId') || '';

    const isEmptyCell = !(id && individualInventoryNumber);

    return (
      <>
        <div className={cl.cell}>
          <div className={cl.header}>
            <span>{cellNumber || (columnIndex + 1) * 100 + rowIndex + 1}</span>
            {isEmptyCell ? (
              <Button
                type="text"
                icon={<PlusOutlined style={{ fontSize: '16px' }} />}
                action={() => onAddIndiv(columnIndex, rowIndex)}
                display={canAction.addToCell}
              />
            ) : (
              <Button
                type="text"
                icon={<DeleteOutlined style={{ fontSize: '16px' }} />}
                action={() => onClearIndiv(id, columnIndex, rowIndex)}
                display={canAction.clearCell}
              />
            )}
          </div>
          {!isEmptyCell && canAction.toIndivCard ? (
            <Link
              style={{
                color: token.colorPrimary,
                textDecoration: 'underline',
                alignSelf: 'flex-start',
              }}
              state={{
                search: `orgId=${orgId}&id=${farmId}&activeCell=${id}`,
                pathname: location.pathname,
              }}
              to={`${VACCIANTION}${REGISTRY}/${id}`}>
              {individualInventoryNumber}
            </Link>
          ) : (
            <span
              style={{
                alignSelf: 'flex-start',
              }}>
              {individualInventoryNumber}
            </span>
          )}
        </div>
      </>
    );
  },
);
